import { DateInputValues } from "../types";

export const extractDateInputValues = (dateString: string | null): DateInputValues => {
  if (!dateString) return { yearInput: "", monthInput: "", dayInput: "" };
  const [yearInput, monthInput, dayInput] = dateString.split("-");
  return { dayInput, monthInput, yearInput };
};
